export default __webpack_public_path__ + "static/media/nohistory.fe7b667e.png";